import { render, staticRenderFns } from "./getsjjt-form.vue?vue&type=template&id=788fb887&scoped=true&"
import script from "./getsjjt-form.vue?vue&type=script&lang=js&"
export * from "./getsjjt-form.vue?vue&type=script&lang=js&"
import style0 from "./getsjjt-form.vue?vue&type=style&index=0&id=788fb887&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788fb887",
  null
  
)

export default component.exports